/**
 * @desc 这里存放测试 预发 生产的域名
 */
export const MUJI_APP_DEPLOY_ENV = process.env.MUJI_APP_DEPLOY_ENV || 'dev';
/**
 * @desc
 * dev:开发
 * prepub：预发 ==> 当测试
 * prod：线上
 */
export const API_BASE = {
    dev: {
        /**
         * uniapi
         */
        suixinhuan: 'http://uniapi.sit.cheyipai.com',
        uniApi: 'https://uniapi.test.cheyipai.com',
        goods: 'http://uniapi.dev.cheyipai.com/auctioncenter/goods',
        order: 'http://uniapi.dev.cheyipai.com/auctioncenter/order',
        user: 'http://uniapi.dev.cheyipai.com/auctioncenter/user',
        systemConfig: 'http://uniapi.dev.cheyipai.com/auctioncenter/config',
        finance: 'http://uniapi.dev.cheyipai.com/auctioncenter/finance',
        auction: 'http://uniapi.dev.cheyipai.com/auctioncenter/auction',
        baseService: 'http://uniapi.dev.cheyipai.com/auctioncenter/basedata',
        reportService: 'http://uniapi.dev.cheyipai.com/auctioncenter/report',
        /**
         * 直连
         */
        goodsDirect: 'http://auctioncenter-goods.souche.dev.dasouche-inc.net',
        orderDirect: 'http://auctioncenter-order.souche.dev.dasouche-inc.net',
        userDirect: 'http://auctioncenter-user.souche.dev.dasouche-inc.net',
        systemConfigDirect: 'http://auctioncenter-config.souche.dev.dasouche-inc.net',
        financeDirect: 'http://auctioncenter-finance.souche.dev.dasouche-inc.net',
        auctionDirect: 'http://auctioncenter-auction.souche.dev.dasouche-inc.net',
        baseServiceDirect: 'http://auctioncenter-basedata.souche.dev.dasouche-inc.net',
        reportServiceDirect: 'http://trade-report-form.souche.dev.dasouche-inc.net/',
    },
    prepub: {
        /**
         * uniapi
         */
        suixinhuan: 'http://uniapi.sit.cheyipai.com',
        uniApi: 'https://uniapi.test.cheyipai.com',
        goods: 'http://uniapi.sit.cheyipai.com/auctioncenter/goods',
        order: 'http://uniapi.sit.cheyipai.com/auctioncenter/order',
        user: 'http://uniapi.sit.cheyipai.com/auctioncenter/user',
        systemConfig: 'http://uniapi.sit.cheyipai.com/auctioncenter/config',
        finance: 'http://uniapi.sit.cheyipai.com/auctioncenter/finance',
        auction: 'http://uniapi.sit.cheyipai.com/auctioncenter/auction',
        baseService: 'http://uniapi.sit.cheyipai.com/auctioncenter/basedata',
        reportService: 'http://uniapi.sit.cheyipai.com/auctioncenter/report',
        /**
         * 直连
         */
        goodsDirect: 'http://auctioncenter.goods.stable.dasouche-inc.net',
        orderDirect: 'http://auctioncenter.order.stable.dasouche-inc.net',
        userDirect: 'http://auctioncenter.user.stable.dasouche-inc.net',
        systemConfigDirect: 'http://auctioncenter.config.stable.dasouche-inc.net',
        financeDirect: 'http://auctioncenter.finance.stable.dasouche-inc.net',
        auctionDirect: 'http://auctioncenter.auction.stable.dasouche-inc.net',
        baseServiceDirect: 'http://auctioncenter.basedata.stable.dasouche-inc.net',
        reportServiceDirect: 'http://trade-report-form.vip.test.suixinhuan.com/',
    },
    prod: {
        /**
         * uniapi
         */
        suixinhuan: 'https://uniapi.cheyipai.com',
        uniApi: 'https://uniapi.cheyipai.com',
        goods: 'https://uniapi.cheyipai.com/auctioncenter/goods',
        order: 'https://uniapi.cheyipai.com/auctioncenter/order',
        user: 'https://uniapi.cheyipai.com/auctioncenter/user',
        systemConfig: 'https://uniapi.cheyipai.com/auctioncenter/config',
        finance: 'https://uniapi.cheyipai.com/auctioncenter/finance',
        auction: 'https://uniapi.cheyipai.com/auctioncenter/auction',
        baseService: 'https://uniapi.cheyipai.com/auctioncenter/basedata',
        reportService: 'https://uniapi.cheyipai.com/auctioncenter/report',
        /**
         * 直连
         */
        goodsDirect: 'https://auction-goods.souche.com',
        orderDirect: 'https://auction-order.souche.com',
        userDirect: 'https://auction-user.souche.com',
        systemConfigDirect: 'https://auction-config.souche.com',
        financeDirect: 'https://auction-finance.souche.com',
        auctionDirect: 'https://auction-core.souche.com',
        baseServiceDirect: 'https://auction-basedata.souche.com',
        reportServiceDirect: 'https://trade-report-form.cheyipai.com/',
    },
}[MUJI_APP_DEPLOY_ENV];
/**
 * 系统中写死的一些环境、地址
 */
export const CONST_URL = {
    dev: {
        loginPageUrl: 'http://sso-acution.souche.dev.dasouche.net/login.htm',
        accountPageUrl: 'http://f2e.dasouche.net/projects/account-management/index.html#/',
        sassHomePageUrl: 'http://f2e.souche.dev.dasouche.net/projects/AuctionSass/background/index.html#/home',
        webUrl: 'http://pusha.dev.cheyipai.com',
        printPageUrl: 'http://f2e.dasouche.net/projects/cheyipai_wireless/cheyipai_f2e/auctionsassprint/index.html#/',
        marketingToolUrl: 'http://f2e.dasouche.net/projects/cheyipai_wireless/cheyipai_f2e/auctionsassmarketing/index.html#/',
        dataOverviewUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/2',
        dataAnalysisUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/1',
    },
    prepub: {
        loginPageUrl: 'http://sso-acution-manager.dasouche.net/login.html',
        accountPageUrl: 'http://f2e.dasouche.net/projects/account-management/index.html#/',
        sassHomePageUrl: 'http://f2e.dasouche.net/projects/AuctionSass/background/index.html#/home',
        webUrl: 'http://pusha.test.cheyipai.com',
        printPageUrl: 'http://f2e.prepub.souche.com/projects/cheyipai_wireless/cheyipai_f2e/auctionsassprint/index.html#/',
        marketingToolUrl: 'http://f2e.prepub.souche.com/projects/cheyipai_wireless/cheyipai_f2e/auctionsassmarketing/index.html#/',
        dataOverviewUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/2',
        dataAnalysisUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/1',
    },
    prod: {
        loginPageUrl: 'http://sso-auction-manager.souche.com/login.html',
        accountPageUrl: 'https://f2e-assets.souche.com/projects/account-management/index.html#/',
        sassHomePageUrl: 'https://am.souche.com/#/home',
        webUrl: 'https://pusha.cheyipai.com',
        printPageUrl: 'https://f2e-assets.souche.com/projects/cheyipai_wireless/cheyipai_f2e/auctionsassprint/index.html#/',
        marketingToolUrl: 'https://f2e-assets.souche.com/projects/cheyipai_wireless/cheyipai_f2e/auctionsassmarketing/index.html#/',
        dataOverviewUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/2',
        dataAnalysisUrl: 'https://f2e-assets.souche.com/projects/nezha-am-web/?mode=screenshot#/dash_edit/-1_1_1/1',
    },
}[MUJI_APP_DEPLOY_ENV];
